/**
 * PatternTrendsCard — Container card for pattern trend bars.
 *
 * Wraps PatternBar instances with section heading.
 * Consent-gated by caller (hidden when can_view_history=false).
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import type { TFunction } from '@dramadetector/shared';
import { GlassCard } from '../../glass/GlassCard';
import { PatternBar } from './PatternBar';

type Trend = 'improving' | 'stable' | 'worsening';

interface PatternTrend {
  id: string;
  name: string;
  score: number;
  trend: Trend;
  maxScore?: number;
}

interface PatternTrendsCardProps {
  trends: PatternTrend[];
  t: TFunction<'practitioner'>;
}

export const PatternTrendsCard: React.FC<PatternTrendsCardProps> = ({ trends, t }) => (
  <GlassCard withChromeBorder={false} noPadding={false}>
    <Text style={styles.heading}>{t('pattern_trends.title')}</Text>
    <View style={styles.list}>
      {trends.map((trend) => (
        <PatternBar
          key={trend.id}
          name={trend.name}
          score={trend.score}
          trend={trend.trend}
          maxScore={trend.maxScore}
          t={t}
        />
      ))}
    </View>
  </GlassCard>
);

const styles = StyleSheet.create({
  heading: {
    fontSize: 14,
    fontWeight: '700',
    color: '#334155',
    marginBottom: 12,
  },
  list: {
    gap: 12,
  },
});
